<template>
  <div id="users" class="sav-wrapper">
		<Spinner v-if="isLoading"/>
		<AlertDialog v-if="alertDialog" visibility="alertDialog" :text="alertDialogText" submitFunction="deleteUser"/>
		<Topbar/>
		<div class="sav-container">
			<Header back="/" title="Διαχείρηση Χρηστών"/>
			<ErrorMsg v-if="errorMsg" :msg="errorMsg"/>
			<table class="sav-table">
				<tr>
					<th>Όνομα</th>
					<th>Username</th>
					<th>Email</th>
					<th>Ημ/νία Τροποποίησης</th>
					<th>Διαχειριστής</th>
					<th>Διαγραφή</th>
				</tr>
				<tr v-for="row in usersData" :key="row.username">
					<td v-for="(value, key, index) in row" :key="index">
						<span v-if="key == 'modified_date'">{{ formatDate(value) }}</span>
						<span v-else-if="key == 'admin' && value == 1">ΝΑΙ</span>
						<span v-else-if="key == 'admin' && value == 0">ΟΧΙ</span>
						<span v-else>{{ value }}</span>
					</td>
					<td>
						<img v-if="!row.admin" @click="showAlertForDelete(row.username)" class="cursor-pointer" :src="require('./../assets/icons/delete.png')"/>
					</td>
				</tr>
			</table>
			<div class="flex flex-justify-content-end">
				<router-link tag="button" to="/register" type="submit" class="sav-btn sav-btn-red">Εγγραφή νέου χρήστη</router-link>
			</div>
		</div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'
import Topbar from './Topbar.vue'
import Header from './Header.vue'
import ErrorMsg from './ErrorMsg.vue'
import AlertDialog from './AlertDialog.vue'

export default {
  props: [],
  components: {
    Spinner,
    Topbar,
		Header,
		ErrorMsg,
		AlertDialog
  },
  data() {
    return {
		isLoading: true,
		apiUrl : this.$parent.apiUrl,
      usersData: '',
			errorMsg: '',
			alertDialog: false,
			userToDelete: '',
			alertDialogText: 'Είστε σίγουρος πως θέλετε να διαγράψετε το χρήστη Φώτης;',
    }
	},
	methods: {
		showAlertForDelete (username) {
			this.alertDialogText = "Είστε σίγουρος ότι θέλετε να διαγράψετε το χρήστη " + username + ";",
			this.userToDelete = username;
			this.alertDialog = true;
		},
		formatDate: function (date) {
      // format date dd/mm/yyyy
      let now = new Date(date);

      return this.sliceNumber(now.getDate(), 2) + "/" + this.sliceNumber(now.getMonth() + 1, 2) + "/" + this.sliceNumber(now.getFullYear(), 4)
    },
    sliceNumber: function(number, slice) {
      // return number with custom number of digits
      return ("0" + number).slice(-1 * slice);
		},
		deleteUser: function() {
			const vm = this;
			vm.isLoading = true;
			let formData = {
				user: JSON.parse(localStorage.getItem('sav-erp-user')),
				userToDelete: vm.userToDelete,
				token: this.$cookie.get('sav-erp-token'),
				refreshToken: this.$cookie.get('sav-erp-refresh-token')
			};

			let headers = { 
				headers: {
				'Content-type': 'application/json',
				}
			};

			axios.post(this.apiUrl + '/post/users/delete', formData, headers)
				.then(response => {
					vm.isLoading = false;
					if (response.status == 200) {
						this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
						this.$router.push("/");
					} else {
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
					}
				})
				.catch(error => {
					let response = error.response;

					if (response.status == 401) {
						localStorage.removeItem('user');    
						vm.$cookie.delete('sav-erp-token');
						vm.$cookie.delete('sav-erp-refresh-token');
						vm.$router.push("/login");
					} else {
						vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
					}
					vm.isLoading = false;
				});
		}
	},
	mounted () {
		const vm = this;
		let formData = {
			user: JSON.parse(localStorage.getItem('sav-erp-user')),
			token: this.$cookie.get('sav-erp-token'),
			refreshToken: this.$cookie.get('sav-erp-refresh-token')
		};

		let headers = { 
		headers: {
		'Content-type': 'application/json',
		}
	};

	axios.post(this.apiUrl + '/get/users/', formData, headers)
		.then(response => {
			vm.isLoading = false;
			if (response.status == 200) {
				this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
				vm.errorMsg = '';
				vm.usersData = response.data.data;
			} else {
				vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
			}
		})
		.catch(error => {
			let response = error.response;

			if (response.status == 401) {
				localStorage.removeItem('user');    
				vm.$cookie.delete('sav-erp-token');
				vm.$cookie.delete('sav-erp-refresh-token');
				vm.$router.push("/login");
			} else {
				vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
				vm.isLoading = false;
			}
		});
	}
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";

tr {
	cursor: auto!important;

	&:hover {
		&:nth-child(even) {
			background-color: white!important;
		}
		&:nth-child(odd) {
			background-color: $light-grey!important;
		}
	}
}
</style>
